


















































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { typetimeout } from '@/directives/input';
import { Base } from '@/components/common/base';
import { VHeaders, VAction } from '@/models/pagedlistmodel';
import { IDialogOption } from '@/models/dialog';
import {
  storeService,
  expenseService,
  customerService,
  laneService,
  paymentService,
  adhocPaymentService
} from '@/shared';
import { StoreSelectList } from '@/models/expense/expense';
// import { LineItem } from "../expense/expense";
import { LineItem } from '@/views/expense/expense';

import { Utils } from '@/helper/utils';
import { depositLogService } from '@/shared';
import { NotificationType, RoleType } from '@/helper/enum';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    isValidate() {
      return (
        this.adhoc.name &&
        this.adhoc.account &&
        this.adhoc.control &&
        this.adhoc.reference &&
        this.selectedPaymentType
      );
      return true;
    },
    computedTotalAmount: {
      get() {
        this.computedTotal = parseFloat(this.getSum(this.lineItems)).toFixed(2);
        return parseFloat(this.getSum(this.lineItems)).toFixed(2);
      },
    },
  },
  components: {
    AppGrid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    //Common payment dialog for every payment provider
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
  },

  directives: {
    typetimeout,
  },
})
export default class AdhocAddComponent extends Base {

  public paymentDialog: boolean = false;
  public computedTotal: string = "";
  public panel: any = [0];
  public adhoc: any = {
    name: '',
    account: '',
    control: '',
    reference: '',
    description: '',
    amount: 0,
    email: '',
    isSendPaymentReceipt: true,
    bypassReason: "",
    isOverrideCCFeeApplied: true,
  };
  public isShowBypassReasonField: boolean = false;
  public lineItem: any = {};
  public dmsStatus: string = '';
  public glErrorMessage: string = '';
  public paymentStatus: string = '';
  public lineItemToDelete: string = '';
  public lineItems: any[] = [];
  public adhocLineItem: string = '';
  public lineProgress: boolean = false;
  public adhocJson: any = {};
  public isShowWarning: boolean = false;
  public warningMessage = '';

  public headers: VHeaders[] = [
    {
      text: 'Account Number',
      align: 'center',
      value: 'accountNumber',
      sortable: true,
    },
    {
      text: 'Control Number',
      align: 'center',
      value: 'controlNumber',
      sortable: true,
    },
    {
      text: 'Reference Number',
      align: 'center',
      value: 'referenceNumber',
      sortable: true,
    },
    {
      text: 'Amount',
      align: 'center',
      value: 'transactionAmount',
      sortable: true,
    },
    {
      text: 'Action',
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public viewHeaders: VHeaders[] = [
    {
      text: 'Account Number',
      align: 'center',
      value: 'accountNumber',
      sortable: true,
    },
    {
      text: 'Control Number',
      align: 'center',
      value: 'controlNumber',
      sortable: true,
    },
    {
      text: 'Reference Number',
      align: 'center',
      value: 'referenceNumber',
      sortable: true,
    },
    {
      text: 'Amount',
      align: 'center',
      value: 'transactionAmount',
      sortable: true,
    },
  ];

  public actions: any[] = [];

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.removeLineItem();
    },
  };


  public glRetryDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.retryAdHocGlPost();
    },
  };

  public duplicateLineItemDialog: IDialogOption = {
    width: 450,
    title: "Confirm Duplicate Line Items",
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: "Continue",
    },
    onAction: (): void => {
      this.addLineItem();
    }
  };

  public IsBypassCreditFeeRole: boolean = false;
  public sendLinkTo: string = 'email';
  public selectedPaymentType: string = '';
  public storeLoading: boolean = false;
  public accountDetailLoading: boolean = false;
  public storeInfo: any = { storeJson: {} };
  public selectedStore: number = null;
  public stores: StoreSelectList[] = [];
  public chargeAccounts: any = [];

  public chargeCustomerAccountsLoaded: boolean = false;

  public storeId: number = 0;
  public dragclass: string = '';
  public attachmentToRemove: any = {};
  public dragging: boolean = false;
  public selectedFiles: any = [];
  public dialogAttachments: IDialogOption = {
    width: 600,
    title: this.$parent.$t('vendorAddPage.dialogAttachmentTitle') as string,
    model: false,
  };
  public attachments: any = [];
  public attachmentsList: any = [];
  public files: any = [];
  public glCompanies: any[] = [];
  public attachmentHeader: VHeaders[] = [
    {
      text: this.$parent.$t('vendorAddPage.attachmentHeader.file') as string,
      align: 'left',
      value: 'id',
      sortable: true,
    },
    {
      text: this.$parent.$t('vendorAddPage.attachmentHeader.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public attachmentActions: VAction[] = [
    {
      type: 'button',
      icon: 'fas fa-eye',
      title: this.$parent.$t(
        'vendorAddPage.attachmentHeader.gridAction.viewAttachment'
      ) as string,
      color: 'primary',
      loading: false,
      visible: (model: any) => true,
      action: (model: any, action: VAction) => {
        // Attachments
      },
    },
    {
      type: 'button',
      icon: 'fas fa-trash-alt',
      title: this.$parent.$t(
        'vendorAddPage.attachmentHeader.gridAction.removeAttachment'
      ) as string,
      color: 'error',
      visible: (model: any) => true,
      action: (model: any) => {
        // attachmentActions
      },
    },
  ];
  public constants = {
    tenantId: 0,
    enterpriseId: 0,
    glCompanyName: '',
  };
  public loading: boolean = false;
  public requestProgress: boolean = false;
  public vendorLoading: boolean = false;
  public disableSaveButton: boolean = false;

  public glCompaniesLoading: boolean = false;

  public accountLoading: boolean = false;
  public cenposDialog: boolean = false;
  public isCloverDialog: boolean = false;
  public paymentProviderLoader: boolean = false;
  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public cenposUrl: string = Utils.WEB_BASE_URL + '/serverpay/cenpos';
  public squareDialog: boolean = false;
  public payrocDialog: boolean = false;
  public paymentProvider: string = '';
  public isCenposConfigured: boolean = false;
  public isCloverConfigured: boolean = false;
  public isPayrocConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public isTerminalPaymentEnabled: boolean = false;

  public isShowView: boolean = false;

  public lanes: any = [];
  public lane: string = '';
  public contactAt: string = '';
  public CustomerEmail: string = '';
  public isLaneLoading: boolean = false;
  public isInvalidEmail = false;

  public receiptNumber: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeName: string = '';
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public startDate: string;
  public endDate: string;

  public confirmDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('adhocPayment.confirmDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('adhocPayment.confirmDialog.lblAgree') as string,
    },
    onAction: (): void => {
      this.payManually();
    },
  };

  public laneDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('adhocPayment.laneDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t('adhocPayment.laneDialog.lblPay') as string,
      disable: false,
    },
    onAction: (): void => {
      this.vantivTerminalPay();
    },
    onClose: (): void => {
      this.moveBack();
    }
  };

  public moveBack() {
    this.$router.push({ name: 'app.adhocPayment' });
  }

  public customerInfoDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('adhocPayment.customerInfoDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t(
        'adhocPayment.customerInfoDialog.lblSend'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.sendPaymentLink();
    },
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public changeStore(store: number) {
    this.getChargeAccounts(store);
  }

  public removeLineItem(): void {
    this.lineItems = this.lineItems.filter((item) => {
      return item.id !== this.lineItemToDelete;
    });
    this.deleteDialog.model = false;
  }

  public setAction() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        color: 'error',
        title: 'Delete line items',
        visible: (model) => {
          return this.isShowView == true ? false : true;
        },
        action: (model) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public showBypassReasonField(value: boolean) {
    if (!value) {
      this.isShowBypassReasonField = true;
    } else {
      this.isShowBypassReasonField = false;
      this.adhoc.bypassReason = '';
      this.adhocJson.bypassReason = '';
    }
  }

  public confirmDelete(item: any): void {
    this.deleteDialog.model = true;
    this.lineItemToDelete = item.id;
  }

  public async sendPaymentLink(): Promise<void> {
    if (this.sendLinkTo == 'phone') {
      if (!this.contactAt || this.contactAt === '0') {
        //this.showAlert(false, 'Contact number is required');
        this.showNotification(NotificationType.Warning, "Contact number is required");
        return;
      }
    } else if (this.sendLinkTo == 'email') {
      if (!this.CustomerEmail || this.CustomerEmail === '') {
        // this.showAlert(false, 'Email is required');
        this.showNotification(NotificationType.Warning, "Email is required");
        return;
      }
      if (!this.isInvalidEmail) {
        // this.showAlert(false, 'Invalid Email');
        this.showNotification(NotificationType.Warning, "Invalid Email");
        return;
      }
    }
    var totalAmount = this.getSum(this.adhocJson.lineItems);
    if (Number(totalAmount) < 0) {
      // this.showAlert(false, 'Amount Should be greater than 0');
      this.showNotification(NotificationType.Warning, "Amount should be greater than 0");
      return;
    }

    try {
      this.customerInfoDialog.loading = true;
      await paymentService.sendAdhocPaymentLink(
        this.contactAt,
        this.CustomerEmail,
        this.adhocJson,
        this.adhoc.isOverrideCCFeeApplied,
        this.adhoc.bypassReason
      );
      // this.showAlert(true, 'Link sent successfully');
      this.showNotification(NotificationType.Success, "Link sent successfully");
      this.$router.push({ name: 'app.adhocPayment' });
    } finally {
      this.customerInfoDialog.loading = false;
      this.customerInfoDialog.model = false;
    }
  }

  public validateEmail(email) {
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.isInvalidEmail = re.test(String(email).toLowerCase());
    return this.isInvalidEmail;
  }

  public getSum(lineItems) {
    if (!lineItems) {
      return 0;
    }
    const lineItemsAmount = lineItems.map((item) => {
      return parseFloat(item.transactionAmount);
    });
    if (!lineItemsAmount || lineItemsAmount.length < 1) {
      return 0;
    }
    return lineItemsAmount.reduce((total, lineItem) => {
      return total + lineItem;
    });
  }

  public async payManually(): Promise<void> {
    try {
      this.confirmDialog.loading = true;
      const depositLog = await paymentService.adhocVantivPay(this.adhocJson);

      window.location.href = depositLog.paymentUrl;
    } finally {
      this.confirmDialog.loading = false;
      this.confirmDialog.model = false;
    }
  }

  public async findLanes(): Promise<void> {
    try {
      this.warningMessage = '';
      this.isShowWarning = false;
      this.laneDialog.action.disable = false;
      this.loading = true;
      this.getLanes();
    } finally {
      this.loading = false;
    }
  }

  public async getLanes(): Promise<void> {
    try {
      this.isLaneLoading = true;
      this.laneDialog.model = true;
      const lanes = await laneService.getLanesAsync();
      this.lane = '';
      this.lanes = lanes.results;
    } finally {
      this.isLaneLoading = false;
    }
  }

  public async vantivTerminalPay(): Promise<void> {
    if (!this.lane) {
      // this.showAlert(false, this.$t('adhocPayment.laneAlert'));
      this.showNotification(NotificationType.Warning, this.$t('adhocPayment.laneAlert'));
      return;
    }
    var totalAmount = this.getSum(this.adhocJson.lineItems);
    if (Number(totalAmount) < 0) {
      // this.showAlert(false, 'Amount Should be greater than 0');
      this.showNotification(NotificationType.Warning, 'Amount should be greater than 0');
      return;
    }

    try {
      this.laneDialog.loading = true;
      var response = await paymentService.adhocTerminalPay(this.lane, this.adhocJson);
      var isApproved = false;
      var isInProcess = false;
      var isFailed = false;
      //For Payroc payments, the payment status is updated via a web job, so there's no need to check the payment status repeatedly
      if (this.paymentProvider != 'Payroc') {
        for (var i = 0; i <= 3; i++) {
          await new Promise((resolve) => setTimeout(resolve, 15000)); // 3 sec
          const paymentResponse = await paymentService.getPaymentDetailStatus(
            response.transactionHeaderId,
            response.transactionDetailId
          );

          if (paymentResponse.status == 'Approved') {
            isApproved = true;
            break;
          }
        }
      } else {
        const paymentResponse = await paymentService.getPaymentDetailStatus(
          response.transactionHeaderId,
          response.transactionDetailId
        );
        if (paymentResponse.status == 'InProcess') {
          isInProcess = true;
        }
        else if (paymentResponse.status == 'Failed') {
          isFailed = true;
        }
      }

      this.isShowWarning = true;
      if (isFailed) {
        this.laneDialog.model = false;
        this.moveBack();
        // this.showAlert(false, "Payment Failed. Please Try Again");
        this.showNotification(NotificationType.Error, 'Payment Failed. Please Try Again');

      }
      else if (isInProcess) {
        this.warningMessage = "Payment Created Successfully, Please check the payment final status in Payment report.";
      }
      else if (isApproved) {
        this.warningMessage = "Payment is Approved Successfully.";
        // this.showAlert(true, "Payment is Approved Successfully.");
        this.showNotification(NotificationType.Success, 'Payment Approved Successfully.');
      }
      else {
        //this.showAlert(true, response.responseMessage);
        this.warningMessage = "Approving Payment callback taking a longer time, Please check the payment final status in Payment report.";
      }

      this.laneDialog.action.disable = true;

    } finally {
      this.laneDialog.loading = false;

    }
  }

  public submit() {
    if (this.validateForm()) {

      if (this.adhoc.name == '') {
        // this.showAlert(false,'Please add Name');
        this.showNotification(NotificationType.Warning, 'Please add Name');
        return;
      }
      if (this.lineItems.length <= 0) {
        // this.showAlert(false, 'Please add line items');
        this.showNotification(NotificationType.Warning, 'Please add line items');
        return;
      }

      if (this.selectedPaymentType == '') {
        // this.showAlert(false, 'Please Select Payment');
        this.showNotification(NotificationType.Warning, 'Please Select Payment');
        return;
      }

      if (this.isShowBypassReasonField && this.adhoc.bypassReason == "") {
        return;
      }

      if (this.lineItems.length > 0) {

        this.adhocJson.urlTenantId = this.tenantId;
        this.adhocJson.urlEnterpriseId = this.enterpriseId;
        this.adhocJson.urlStoreId = this.storeId;
        this.adhocJson.name = this.adhoc.name;
        this.adhocJson.email = this.adhoc.email;
        this.adhocJson.laneId = this.lane;
        this.adhocJson.paymentType = this.selectedPaymentType;
        this.adhocJson.accountNumber = this.adhoc.account;
        this.adhocJson.controlNumber = this.adhoc.control;
        this.adhocJson.lineItems = this.lineItems;
        this.adhocJson.referenceNumber = this.adhoc.reference;
        this.adhocJson.description = this.adhoc.description;
        this.adhocJson.amount = this.$props.computedTotalAmount;
        this.adhocJson.url = this.currentUrl;
        this.adhocJson.isSendPaymentReceipt = this.adhoc.isSendPaymentReceipt;
        this.CustomerEmail = this.adhoc.email ? this.adhoc.email : '';
        this.adhocJson.isOverrideCCFeeApplied = this.adhoc.isOverrideCCFeeApplied;
        this.adhocJson.bypassReason = this.adhoc.bypassReason;

        var totalAmount = this.getSum(this.adhocJson.lineItems);
        if (Number(totalAmount) < 0) {
          // this.showAlert(false, 'Amount Should be greater than 0');
          this.showNotification(NotificationType.Warning, 'Amount should be greater than 0');
          return;
        }

        switch (this.selectedPaymentType) {
          case 'rdVantiv':
            this.findLanes();
            break;
          case 'rdText':
            this.contactAt = '';
            this.customerInfoDialog.model = true;
            break;
          case 'rdManual':
            if (this.paymentProvider == 'Vantiv') {
              this.confirmDialog.model = true;
            } else {
              this.paymentDialog = true;
              this.$root.$emit('validatePaymentProvider');
            }
            break;
          default:
        }
      } else {
        // this.showAlert(false, 'Please add line items first');
        this.showNotification(NotificationType.Warning, 'Please add line items first');
      }
    }
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    } else if (methodName === 'save') {
      // this.validateAndSaveVendor();
    } else if (methodName === 'RetryGlPost') {
      this.glRetryDialog.model = true;
    }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('vendorAddPage.btnBackToList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('vendorAddPage.labelBackToList'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    if (this.dmsStatus === 'Failed') {
      buttons.push({
        id: '1',
        type: 'button',
        title: 'Retry GL post',
        disabled: false,
        visible: true,
        class: 'btn',
        label: 'Retry GL post',
        click: 'RetryGlPost',
        icon: 'fas fa-redo-alt',
        requestProgress: true,
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'adhocPayment');

    // Toolbar
    this.updateToolBar();

    this.$watch(
      "adhoc",
      (newVal) => {
        this.paymentOptions.name = newVal.name;
        this.paymentOptions.account = newVal.account;
        this.paymentOptions.control = newVal.control;
        this.paymentOptions.reference = newVal.reference;
        this.paymentOptions.description = newVal.description;
        this.paymentOptions.isSendPaymentReceipt = newVal.isSendPaymentReceipt;
        this.paymentOptions.isOverrideCCFeeApplied = newVal.isOverrideCCFeeApplied;
        this.paymentOptions.bypassReason = newVal.bypassReason;
      },
      {
        deep: true, // Enables deep watching
      }
    );

    this.$watch('computedTotal', (newVal) => {
      this.paymentOptions.amount = newVal;
    });

    this.$watch('CustomerEmail', (newVal) => {
      this.paymentOptions.customerEmail = newVal;
    });

    this.$watch('adhocLineItem', (newVal) => {
      this.paymentOptions.lineItems = newVal;
    });
    var role = [RoleType.BypassCreditCardFee.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.IsBypassCreditFeeRole = isRoleAllowed.includes(role[0]);

    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.query['startDate'] && this.$route.query['endDate']) {
      this.startDate = (this.$route.query['startDate'] || '').toString().trim();
      this.endDate = (this.$route.query['endDate'] || '').toString().trim();
    }
    this.getDefaultPaymentType();
    this.currentUrl = window.location.href;
    this.OnInit();

  }

  public backToList() {
    // this.$router.push({
    //   name: 'app.adhocPayment',
    //   query:{
    //     startDate: this.startDate,
    //     endDate: this.endDate
    //   }
    // });
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.adhocPayment' });
    }
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      this.paymentProviderLoader = true;
      const result = await depositLogService.getDefaultPaymentProvider(
        this.userSession.storeId
      );
      this.isTerminalPaymentEnabled = result.isTerminalPaymentEnabled;
      this.paymentProvider = result.paymentProvider;
      this.storeId = result.storeId;
      this.tenantId = result.tenantId;
      this.enterpriseId = result.enterpriseId;
      this.storeName = result.storeName;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;
      this.isCloverConfigured = result.isCloverConfigured;
      this.isCenposConfigured = result.isCenposConfigured;
      this.isSquareConfigured = result.isSquareConfigured;
      this.isPayrocConfigured = result.isPayrocConfigured;

    } finally {
      this.paymentProviderLoader = false;
    }
  }

  public async OnInit(): Promise<void> {
    if (!this.storeId) {
      setTimeout((x) => {
        this.OnInit();
      }, 500);
      return;
    }
    this.getStore();
    this.setAction();
    if (this.$route.params.id) {
      this.isShowView = true;
      this.receiptNumber = Number(this.$route.params.id);
      this.getAdHocLineItemDetail(this.receiptNumber);
    } else {
      this.getChargeAccounts(this.storeId);
      this.getAdhocAccountDetails();
    }

    this.$watch('lineItem.accountNumber', (newVal, oldVal) => {
      if (newVal) {
        const accountDetails = this.getAccountDetails(
          this.chargeAccounts,
          newVal
        );
        this.$set(
          this.lineItem,
          'department',
          accountDetails.department || 'GN'
        );
        this.getChargeCustomerTransAmount();
      }
    });
  }

  public async getAdhocAccountDetails() {
    try {
      this.accountDetailLoading = true;
      const adhocRes = await adhocPaymentService.getAdhocAccountDetails(
        this.storeId
      );
      if (adhocRes) {
        this.adhoc.account = adhocRes.accountNumber;
        this.adhoc.control = adhocRes.controlNumber;
        this.adhoc.reference = adhocRes.referenceNumber;
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      this.accountDetailLoading = false;
    }
  }

  public async retryAdHocGlPost() {
    try {
      this.glRetryDialog.loading = true;
      var adhocRes = await adhocPaymentService.retryAdHocGlPostRequest(
        this.receiptNumber
      );
      if (adhocRes.isSuccess) {
        // this.showAlert(true, 'Gl Data Posted Successfully');
        this.showNotification(NotificationType.Success, 'GL Data Posted Successfully');
        window.location.reload();
      } else {
        // this.showAlert(false, adhocRes.responseStatus.message);
        this.showNotification(NotificationType.Warning, adhocRes.responseStatus?.message || 'Failed to post GL data');
      }
    } catch (ex) {
      console.log(ex);
      // this.showAlert(false, adhocRes.responseStatus.message);
      this.showNotification(NotificationType.Error, adhocRes.responseStatus.message || 'An error occurred while retrying GL post');
    } finally {
      this.glRetryDialog.loading = false;
    }
  }

  public async getAdHocLineItemDetail(receiptNumber: number) {
    try {
      this.loading = true;
      this.accountDetailLoading = false;
      const adhocRes = await adhocPaymentService.getAdHocLineItemDetail(
        receiptNumber
      );
      if (adhocRes) {
        this.adhoc.account = adhocRes.accountNumber;
        this.adhoc.control = adhocRes.controlNumber;
        this.adhoc.reference = adhocRes.referenceNumber;
        this.adhoc.name = adhocRes.name;
        this.adhoc.description = adhocRes.description;
        this.adhoc.amount = adhocRes.amount;
        this.adhoc.email = adhocRes.email;
        this.dmsStatus = adhocRes.glStatus;
        this.paymentStatus = adhocRes.paymentStatus;
        this.glErrorMessage = adhocRes.glErrorMessage;

        this.lineItems = adhocRes.lineItems;
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      this.loading = false;
      this.accountDetailLoading = false;
      this.updateToolBar();
    }
  }

  public getAccountDetails(chargeAccounts: any[], accountNumber: string) {
    return chargeAccounts.filter((item) => {
      return item.accountNumber === accountNumber;
    })[0];
  }

  public updateCenposDialog(cenposDialogVaue) {
    this.cenposDialog = cenposDialogVaue;
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }
  public updatePayrocDialog(payrocDialogValue) {
    this.payrocDialog = payrocDialogValue;
  }
  public async getChargeCustomerTransAmount(): Promise<void> {
    this.lineItem.accountAmount = 'N/A';
    if (!this.lineItem.accountNumber) {
      return;
    }
    let controlNumber;
    if (this.lineItem.controlNumber) {
      controlNumber = this.lineItem.controlNumber;
    }
    if (!controlNumber) {
      return;
    }
    const accountDetails = this.getAccountDetails(
      this.chargeAccounts,
      this.lineItem.accountNumber
    );
    if (
      accountDetails.accountType === '1' ||
      accountDetails.accountType === '2'
    ) {
      try {
        const response = await customerService.getChargeCustomerTransAmount(
          controlNumber,
          this.lineItem.accountNumber
        );
        this.lineItem.accountAmount = response;
      } finally {
        // this.removeError('Account Amount');
      }
    }
  }

 public async confirmDuplicateLineItem(): Promise<void> {
  let isDuplicate = false;
  try {
    const { accountNumber, transactionAmount, controlNumber, referenceNumber } = this.lineItem;

    // --- Validation checks ---
    if (!accountNumber || !transactionAmount || !controlNumber) {
      isDuplicate = false;
    }

    const amountStr = transactionAmount?.toString() || '';
    if (amountStr === '0' || amountStr === '-0') {
      isDuplicate = false;
    }

    // --- Parse existing items safely ---
    let existingItems: any[] = [];
    try {
      if (this.adhocLineItem) {
        existingItems = Array.isArray(this.adhocLineItem)
          ? this.adhocLineItem
          : JSON.parse(this.adhocLineItem || '[]');
      }
    } catch (parseErr) {
      console.error('Failed to parse adhocLineItem JSON:', parseErr);
      existingItems = [];
    }

    // --- Duplicate check with null safety and fixed decimal comparison ---
    isDuplicate = existingItems.some((x: any) => {
      if (!x) return false;
      return (
        x.accountNumber === accountNumber &&
        x.referenceNumber === referenceNumber &&
        x.controlNumber === controlNumber &&
        parseFloat(x.transactionAmount || '0').toFixed(2) ===
          parseFloat(transactionAmount || '0').toFixed(2)
      );
    });
  } catch (err) {
    console.error('Error in confirmDuplicateLineItem:', err);
    isDuplicate = false; // fallback default
  }

  // --- Final Action ---
  if (isDuplicate) {
    this.duplicateLineItemDialog.model = true;
  } else {
    await this.addLineItem();
  }
}

  public async addLineItem(): Promise<void> {
    try {
      if (!(await this.validateFormByScope('lineItemsToAdd'))) {
        return;
      }
      if (this.lineItem.accountNumber == undefined) {
        // this.showAlert(false, 'Please Select Account Number');
        this.showNotification(NotificationType.Warning, 'Please Select Account Number');
        return;
      }

      if (this.lineItem.transactionAmount == undefined) {
        // this.showAlert(false, 'Please add amount');
        this.showNotification(NotificationType.Warning, 'Please add amount');
        return;
      }

      if (this.lineItem.controlNumber == undefined) {
        // this.showAlert(false, 'Please add control Number');
        this.showNotification(NotificationType.Warning, 'Please add control Number');
        return;
      }

      if (
        this.lineItem.transactionAmount === '0' ||
        this.lineItem.transactionAmount === '-0'
      ) {
        // this.showAlert(false, 'Amount can not be Zero');
        this.showNotification(NotificationType.Warning, 'Amount cannot be Zero');
        return;
      }

      let storeName = '';
      let storeId;
      if (this.selectedStore) {
        storeId = this.selectedStore;
        this.stores.map((x) => {
          if (x.storeId === storeId) {
            storeName = x.storeName;
            return;
          }
        });
      }
      if (this.lineItem.accountNumber.indexOf('*') !== -1) {
        this.lineProgress = true;
      } else {
        this.lineItems.push(
          new LineItem({
            id: Utils.newGuid(),
            accountNumber: this.lineItem.accountNumber,
            referenceNumber: this.lineItem.referenceNumber,
            controlNumber: this.lineItem.controlNumber,
            partNumber: this.lineItem.partNumber,
            description: this.lineItem.description,
            department: this.lineItem.department,
            accountSubType: this.lineItem.accountSubType,
            comment: this.lineItem.comment,
            transactionAmount: parseFloat(
              parseFloat(`${this.lineItem.transactionAmount}`).toFixed(2)
            ),
            storeId: this.lineItem.storeId,
            storeName: storeName,
          })
        );
      }

      this.lineItem = {};

      const adhocLine = JSON.stringify(this.lineItems);

      this.adhocLineItem = adhocLine;

      if (this.lineItems.length > 0) {
        this.lineItems.forEach((x) => {
          this.adhoc.amount += parseFloat(x.transactionAmount).toFixed(2);
        });
      }
    } catch {}
     finally {
      this.duplicateLineItemDialog.model = false;
    }
  }

  public async getChargeAccounts(storeId: number): Promise<void> {
    try {
      this.accountLoading = true;
      const accounts = await expenseService.getStoreChargeAccountsAsync(
        storeId
      );
      this.chargeCustomerAccountsLoaded = true;
      this.chargeAccounts = accounts.results;
    } catch (e) {
      this.chargeAccounts = [];
    } finally {
      this.accountLoading = false;
    }
  }

  public async getStore(): Promise<void> {
    try {
      const vm = this;
      this.storeLoading = true;
      const storeDetails = await storeService.getStoreDetails(this.storeId);
      this.storeInfo = storeDetails;
      const selected = {
        storeId: this.storeInfo.id,
        storeName: this.storeInfo.storeJson.name,
      } as StoreSelectList;
      this.stores.push(selected);
      this.selectedStore = selected.storeId;
    } finally {
      this.storeLoading = false;
    }
  }

  public created(): void {
    this.storeId = this.userSession.storeId;
    this.enterpriseId = this.userSession.enterpriseId;
    this.tenantId = this.userSession.tenantId;
  }
  public paymentOptions: IPaymentDialog = {
    id: "adhocPayment",
    url: window.location.href,
    amount: Number(this.computedTotal),
    customerEmail: this.CustomerEmail,
    recordIdentifier: "AdHoc",
    type: "0",
    showTextField: false,
    name: this.adhoc.name,
    account: this.adhoc.account,
    control: this.adhoc.control,
    reference: this.adhoc.reference,
    description: this.adhoc.description,
    lineItems: this.adhocLineItem,
    isSendPaymentReceipt: this.adhoc.isSendPaymentReceipt,
    isOverrideCCFeeApplied: this.adhoc.isOverrideCCFeeApplied,
    bypassReason: this.adhoc.bypassReason,

  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
